// src/components/co-ownership/CoOwnershipRisks.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import {Button} from '@dopomogai/ui';

interface CoOwnershipRisksProps {
  onAction: (actionType: string, payload?: any) => void;
}

export const CoOwnershipRisks: React.FC<CoOwnershipRisksProps> = ({ onAction }) => {
  const { t } = useTranslation('co_ownership');
  const risksData = t('risks', { returnObjects: true }) as any;

  return (
    <section className="bg-slate-100 py-16 md:py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto bg-white p-8 md:p-10 rounded-xl border-2 border-black"
        >
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{risksData.headline}</h2>
            <p className="mt-4 text-lg text-slate-600">{risksData.intro}</p>
          </div>
          <ul className="space-y-4 mt-8">
            {risksData.points.map((point: any, index: number) => (
              <li key={index} className="flex items-start gap-3 p-4 bg-amber-50 border-2 border-amber-300 rounded-lg">
                <AlertTriangle className="text-amber-500 mt-0.5 shrink-0" size={20} />
                <span className="text-amber-900 font-medium">{point.text}</span>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-center font-bold text-slate-800">{risksData.finalStatement}</p>
          <div className="mt-8 flex justify-center">
            <Button
              text={risksData.ctaFaq}
              variant="outline"
              onClick={() => onAction('NAVIGATE_TO_PAGE', { path: '/faq#supporters' })}
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
